export async function getOrientation(blob: Blob): Promise<number> {
  const buffer = await blob.arrayBuffer();
  const view = new DataView(buffer);
  if (view.getUint16(0, false) !== 0xffd8) return 1;
  let offset = 2;
  while (offset < view.byteLength) {
    const marker = view.getUint16(offset, false);
    offset += 2;
    if (marker === 0xffe1) {
      // Exif marker
      if (view.getUint32(offset + 2, false) !== 0x45786966) break;
      const little = view.getUint16(offset + 8, false) === 0x4949;
      const tiffOffset = offset + 10;
      const firstIFDOffset = view.getUint32(tiffOffset + 4, little);
      offset = tiffOffset + firstIFDOffset;
      const tags = view.getUint16(offset, little);
      for (let i = 0; i < tags; i++) {
        const tagOffset = offset + 2 + i * 12;
        if (view.getUint16(tagOffset, little) === 0x0112) {
          return view.getUint16(tagOffset + 8, little);
        }
      }
    } else if ((marker & 0xff00) !== 0xff00) {
      break;
    } else {
      offset += view.getUint16(offset, false);
    }
  }
  return 1;
}

export async function getDateTimeOriginal(blob: Blob): Promise<string | null> {
  const buffer = await blob.arrayBuffer();
  const view = new DataView(buffer);
  if (view.getUint16(0, false) !== 0xffd8) return null;
  let offset = 2;
  while (offset < view.byteLength) {
    const marker = view.getUint16(offset, false);
    offset += 2;
    if (marker === 0xffe1) {
      if (view.getUint32(offset + 2, false) !== 0x45786966) break;
      const little = view.getUint16(offset + 8, false) === 0x4949;
      const tiffOffset = offset + 10;
      const firstIFDOffset = view.getUint32(tiffOffset + 4, little);
      const ifdOffset = tiffOffset + firstIFDOffset;
      const entries = view.getUint16(ifdOffset, little);
      for (let i = 0; i < entries; i++) {
        const entry = ifdOffset + 2 + i * 12;
        const tag = view.getUint16(entry, little);
        if (tag === 0x8769) {
          const exifOffset = tiffOffset + view.getUint32(entry + 8, little);
          const count = view.getUint16(exifOffset, little);
          for (let j = 0; j < count; j++) {
            const e = exifOffset + 2 + j * 12;
            if (view.getUint16(e, little) === 0x9003) {
              const len = view.getUint32(e + 4, little);
              const valOffset = tiffOffset + view.getUint32(e + 8, little);
              let str = '';
              for (let k = 0; k < len; k++) {
                const c = view.getUint8(valOffset + k);
                if (c === 0) break;
                str += String.fromCharCode(c);
              }
              return str;
            }
          }
        }
      }
    } else if ((marker & 0xff00) !== 0xff00) {
      break;
    } else {
      offset += view.getUint16(offset, false);
    }
  }
  return null;
}
